import "./css/ContactSection.scss";
import Container from "react-bootstrap/Container";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

function SkillSection() {
  return (
    <Container>
      <section className="pt-5" id="contact">
        <h2 className="mb-4 border-bottom">Contact me</h2>

        <div className="d-flex flex-wrap gap-3">
          <ButtonGroup>
            <Button className="d-flex flex-wrap justify-content-center align-items-center gap-2" variant="outline-secondary" href="mailto:r.achuthan2001@gmail.com" target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/fluency/96/mail.png" alt="Mail icon" width="32" height="32" />
              Email me
            </Button>
            <span className="ContactSection__text-btn text-secondary border border-start-0 border-secondary rounded-end">r.achuthan2001@gmail.com</span>
          </ButtonGroup>
          <Button className="d-flex align-items-center gap-2" variant="outline-secondary" href="https://www.linkedin.com/in/achuthan-r/" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/fluency/96/linkedin.png" alt="LinkedIn logo" width="32" height="32" />
            LinkedIn
          </Button>
          <Button className="d-flex align-items-center gap-2" variant="outline-secondary" href="https://github.com/AchuthanR/" target="_blank" rel="noopener noreferrer">
            <img src="https://img.icons8.com/fluency/96/github.png" alt="GitHub logo" width="32" height="32" />
            GitHub
          </Button>
        </div>
      </section>
    </Container>
  );
}

export default SkillSection;